import React from "react";
import { IoChevronForward } from "react-icons/io5";

interface ArrowArgs {
  direction: string
}

export default function Arrow(args: ArrowArgs) {
 return <IoChevronForward size={15} className={`${args.direction}`} />
}